import { route } from 'preact-router';
import { error, clients } from '../store/state';
import { crearVisita } from '../store/actions/visit.actions';
import { esDiaPermitido, MENSAJE_DIA_NO_PERMITIDO } from '../utils/businessDays';
import { Shell } from '../layout/Shell';
import type { VisitTipo } from '../api/types';

export function NuevaVisitaView() {
  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const tipo = fd.get('tipo') as VisitTipo;
    const fecha = new Date(String(fd.get('fechaProgramada')));
    if (tipo !== 'emergencia' && !esDiaPermitido(fecha)) {
      error.value = MENSAJE_DIA_NO_PERMITIDO;
      return;
    }
    try {
      await crearVisita(String(fd.get('clientId')), fecha.toISOString(), tipo);
      route('/agenda');
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="agenda">
      <h2>Agendar visita</h2>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Cliente</label>
        {clients.value.length ? (
          <select name="clientId" required>
            {clients.value.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nombre}
                {c.zona ? ` (${c.zona})` : ''}
              </option>
            ))}
          </select>
        ) : (
          <input name="clientId" required />
        )}
        <label>Fecha y hora</label>
        <input name="fechaProgramada" type="datetime-local" required />
        <p class="muted" style={{ margin: '2px 0 0', fontSize: 12 }}>
          Las visitas programadas solo se pueden agendar martes, jueves o viernes.
        </p>
        <label>Tipo</label>
        <select name="tipo">
          <option value="programada">Programada</option>
          <option value="emergencia">Emergencia (no reinicia ciclo)</option>
        </select>
        <button class="primary" type="submit">
          Agendar
        </button>
        <button class="secondary" type="button" onClick={() => route('/agenda')}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
